import {LegacyRegulationWrapper} from "../legacy-regulation-wrapper";
import {DialogResult} from "../../specific-dialogs/specific-dialogs.service.interface";

export class SpainRegulation extends LegacyRegulationWrapper {
    async logoutUser(): Promise<void> {
        const dialogResult = await this.services.specificDialogs.showLogoutGamblingSessionSummary();
        if(dialogResult === DialogResult.Accepted) {
            await super.logoutUser();
        }
    }
}